import { render, staticRenderFns } from "./research-center.vue?vue&type=template&id=2b21d1a3&scoped=true"
import script from "./research-center.vue?vue&type=script&lang=js"
export * from "./research-center.vue?vue&type=script&lang=js"
import style0 from "./research-center.vue?vue&type=style&index=0&id=2b21d1a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b21d1a3",
  null
  
)

export default component.exports